export * from './lib/front-shared-home-feature/front-shared-home-feature.component';
export * from './lib/front-shared-home-feature/lib.route'
